import * as React from 'react';
import { clsx as cx } from 'clsx';
import styles from './styles.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Обертка для элементов форм, которая позволяет указать лейбл и ошибку
 *
 * Имеет внешний отступ снизу, который можно отключить
 */
export var FormField = /*#__PURE__*/React.forwardRef(function FormField(props, ref) {
  var label = props.label,
    errorMessage = props.errorMessage,
    required = props.required,
    withoutMargin = props.withoutMargin,
    children = props.children;
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    className: cx(styles['field'], !!label && styles['hasLabel'], !!errorMessage && styles['hasError'], !!withoutMargin && styles['withoutMargin']),
    children: [label && /*#__PURE__*/_jsx("label", {
      className: cx(styles['label'], !!required && styles['required']),
      children: label
    }), children, errorMessage && /*#__PURE__*/_jsx("div", {
      className: styles['error'],
      children: errorMessage
    })]
  });
});